import React from 'react';

export const AiIcon = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 100C77.6142 100 100 77.6143 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6143 22.3858 100 50 100Z" fill="#2A4CA4" />
    <path
      d="M44 26L49.9 46.1L70 52L49.9 57.9L44 78L38.1 57.9L18 52L38.1 46.1L44 26Z"
      fill="white"
    />
    <path
      d="M69 22L71.95 31.05L81 34L71.95 36.95L69 46L66.05 36.95L57 34L66.05 31.05L69 22Z"
      fill="white"
    />
  </svg>
);
